module.exports = "/_next/static/images/59674f1cb78401fe97f6c55c6b87569c-apply-bullet-2.jpeg";